import { STORAGE_KEYS, SUBSCRIPTION_TYPE, PLAN_STATUS } from 'const';
import { roundOff } from 'helpers/NumberFormatHelper';
import { featureIsExpired } from 'components/utils/FeatureValidityExpire';

function saveSelectedShopDetails(shop) {
  localStorage.setItem(STORAGE_KEYS.SHOP_ID, shop.id);
  localStorage.setItem(STORAGE_KEYS.SHOP_NAME, shop.shop_name);
  localStorage.setItem(STORAGE_KEYS.USER_TYPE, shop.subscription.type);
}

function hasPremiumAccess(shop) {
  return shop && shop.subscription?.type === SUBSCRIPTION_TYPE.PREMIUM;
}

function isFreePlan(shop) {
  return shop?.subscription?.type === SUBSCRIPTION_TYPE.FREE;
}

function isBasicPlan(shop) {
  return shop?.subscription?.type === SUBSCRIPTION_TYPE.BASIC;
}

function getAdEligibleUsers(shop) {
  return shop?.plan_status === PLAN_STATUS.FREE || shop?.plan_status === PLAN_STATUS.TRIAL;
}

function getSubscriptionRemainingDays(shop) {
  if (!shop) return;
  const subscriptionEndDate = new Date(shop.subscription_end_date);
  const milliSecondsPerDay = 1000 * 60 * 60 * 24;
  const subscriptionRemainingDays = (subscriptionEndDate.getTime() - new Date().getTime()) / milliSecondsPerDay;
  return Math.round(subscriptionRemainingDays).toFixed(0);
}

function getAmountDecimalCount(shop) {
  return shop?.tax_region?.toLowerCase() === 'oman' ? 3 : 2;
}

function getAmountFormatted(shop, amount) {
  return roundOff(amount, getAmountDecimalCount(shop));
}

function isAdSupportedPlan(shop) {
  return shop?.plan_status === PLAN_STATUS.FREE || shop?.plan_status === PLAN_STATUS.TRIAL;
}

function generateBatchName(date = new Date(), vendor = null) {
  if (!date) return '';
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  const hh = date.getHours().toString().padStart(2, '0');
  const mm = date.getMinutes().toString().padStart(2, '0');

  let base = `${y}/${m}/${d}-${hh}:${mm}`;
  if (vendor?.name) {
    base += `-${vendor.name.replace(/\s+/g, '_')}`;
  }
  return base;
}

function isWarehouseFeatureActive(shop) {
  return !featureIsExpired(shop?.warehouse_validity) && shop?.config?.is_warehouse_enabled;
}


const ShopsHelper = {
  saveSelectedShopDetails,
  getSubscriptionRemainingDays,
  getAmountDecimalCount,
  getAmountFormatted,
  hasPremiumAccess,
  isFreePlan,
  isBasicPlan,
  isAdSupportedPlan,
  getAdEligibleUsers,
  generateBatchName,
    isWarehouseFeatureActive,

};

export default ShopsHelper;
